import {useCallback,useRef,useState} from "react";
import {useDispatch} from "react-redux";
import {removeLoginLS} from "@delibrandev/utils";
import {apiRest} from "../api/constants";
import {logout as logOut} from "../api/requests";
import {setAlert,setUserLogOut} from "../reducers/userConfigSlice";

export const useLogout = () => {
 const dispatch=useDispatch();const pending=useRef(false);const [busy,setBusy]=useState(false);
 const logout=useCallback(async()=>{
  if(pending.current)return false;
  pending.current=true;setBusy(true);
  try{
   const response=await logOut();
   if(response?.error!==false)throw new Error("Logout not confirmed");
   removeLoginLS(apiRest);
   dispatch(setUserLogOut());
   return true;
  }catch{
   dispatch(setAlert({called:true,title:"No se pudo cerrar la sesión",message:"Comprueba la conexión y vuelve a intentarlo.",type:"error"}));
   return false;
  }finally{pending.current=false;setBusy(false);}
 },[dispatch]);
 return {logout,busy};
};
